import React from "react";
import {useNavigate} from "react-router-dom";
import {ArrowLeft} from "lucide-react";
import Button from "./Button";

/**
 * Consistent "← Back to Dashboard" action for GPS Lock sub-screens (Command Center, Tasks,
 * Scheduled Unlocks, …) that otherwise have no obvious way back to the landing page.
 */
export default function BackToDashboardButton({className}) {
  const navigate = useNavigate();
  return (
    <Button
      variant="secondary"
      icon={ArrowLeft}
      onClick={() => navigate("/home")}
      className={className}
    >
      Back to Dashboard
    </Button>
  );
}
